import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { LocationSvg, CarSvg, BikeSvg, CycleSvg, AtmLargeSvg, ToiletSvg, FacilitiesSvg, Mediacal, Water, PoliceBooth, Help, WheelChairSvg, Ticket } from '../../common/svg/AllSvg';
import { useNavigate, useParams } from 'react-router-dom';

const StationsFacilities = () => {
	const [data, setData] = useState<any[]>([])
	const [pData, setPData] = useState<any>(null)
	const stationDetailData: any = useSelector((state: any) => state.data.stationDetailData);
	const { t } = useTranslation('common');
	const navigate = useNavigate();
	const params = useParams();

	useEffect(() => {
		if (!!stationDetailData) {
			stationDetailData?.station_facilities?.length > 0 && setData(stationDetailData?.station_facilities)
			stationDetailData?.parkings?.length > 0 && setPData(stationDetailData?.parkings?.[0])
		}
	}, [stationDetailData])

	const redirectToFacility = () => {
		!!params?.lang ? navigate(`/${params?.lang}/passenger/pages/facilities`) : navigate(`/passenger/pages/facilities`)
	}

	return (
		<>
			{/* Station Facility section */}
			<div className='st-facilities-bg w-full bg-[#F6F9FC] dark:bg-[#0B121A] mt-[30px] xlx:mt-[50px] pt-[50px] xlx:pt-[90px]' id='station_facilities'>
				<div className='container w-full pb-[25px]'>
					<div className="flex items-center gap-[9px]">
						<FacilitiesSvg className="fill-[#15539B]" />
						<h5 className='font-bold text-[#15539B] uppercase'>{t('passenger.station_detail.station_facility')}</h5>
					</div>

					{/* <div className="w-full overflow-hidden pt-[18px]">
						<DotsLine />
					</div> */}
				</div>
			</div>

			{/* parking */}
			{!!pData && <div className='bg-[#F6F9FC] dark:bg-[#0B121A] w-full pb-[30px] mt-[-1px] pt-[1px]'>
				<div className="grid grid-cols-1 xsm:grid-cols-2 mms:grid-cols-3 xl:grid-cols-4 gap-[20px] container">
					<div className="bg-white dark:bg-bgDarkDull border border-[#059db280] dark:border-[#ffffff80] min-h-[95px] xlx:min-h-[105px] p-[15px] xlx:px-[31px] xlx:py-[16px] gap-[15px] flex items-center rounded-[15px]">
						<CarSvg />
						<div className='flex flex-col gap-[5px]'>
							<h3 className='font-extrabold text-blackDull dark:text-textBlackDull'>{pData?.capacity_car || 0}</h3>
							<h6 className='text-blackDull dark:text-textBlackDull font-medium'>{t('passenger.station_detail.car_parking')}</h6>
						</div>
					</div>

					<div className="bg-white dark:bg-bgDarkDull border border-[#059db280] dark:border-[#ffffff80] min-h-[95px] xlx:min-h-[105px] p-[15px] xlx:px-[31px] xlx:py-[16px] gap-[15px] flex items-center rounded-[15px]">
						<BikeSvg />
						<div className='flex flex-col gap-[5px]'>
							<h3 className='font-extrabold text-blackDull dark:text-textBlackDull'>{pData?.capacity_motorcycle || 0}</h3>
							<h6 className='text-blackDull dark:text-textBlackDull font-medium'>{t('passenger.station_detail.bike_parking')}</h6>
						</div>
					</div>

					<div className="bg-white dark:bg-bgDarkDull border border-[#059db280] dark:border-[#ffffff80] min-h-[95px] xlx:min-h-[105px] p-[15px] xlx:px-[31px] xlx:py-[16px] gap-[15px] flex items-center rounded-[15px]">
						<CycleSvg />
						<div className='flex flex-col gap-[5px]'>
							<h3 className='font-extrabold text-blackDull dark:text-textBlackDull'>{pData?.capacity_cycle || 0}</h3>
							<h6 className='text-blackDull dark:text-textBlackDull font-medium'>{t('passenger.station_detail.bicycle_parking')}</h6>
						</div>
					</div>
				</div>
			</div>}

			{data?.length > 0 && <div className='mt-[30px] w-full'>
				{Array.isArray(data) && data?.map((item: any, index: number) => (
					<div className={`w-full ${data?.length === (index + 1) ? "" : "pb-[30px]"}`} key={index}>
						<div className='container w-full'>
							<h5 className='font-bold text-blackDull dark:text-textBlackDull pb-[15px]'>
								{item?.kind}
							</h5>

							<div onClick={redirectToFacility} className="grid grid-cols-1 xsm:grid-cols-2 mms:grid-cols-3 xl:grid-cols-4 gap-[20px] hover:cursor-pointer">
								{Array.isArray(item?.detail_list) && item?.detail_list?.map((i: any, idx: number) => (
									<div className="bg-white dark:bg-bgDarkDull border border-[#059db280] dark:border-[#ffffff80] min-h-[95px] xlx:min-h-[105px] p-[15px] xlx:px-[31px] xlx:py-[16px] gap-[12px] flex items-center rounded-[15px]" key={idx}>
										{item?.["icon-class"] === 'food' ?
											<Help className="min-w-[50px]" />
											: item?.["icon-class"] === 'toilet' ?
												<ToiletSvg className="min-w-[50px]" />
												: item?.["icon-class"] === 'ATM' ?
													<AtmLargeSvg className="min-w-[50px]" />
													: item?.["icon-class"] === 'medical' ?
														<Mediacal className="min-w-[50px]" />
														: item?.["icon-class"] === 'water' ?
															<Water className="min-w-[50px]" />
															: item?.["icon-class"] === 'police-booth' ?
																<PoliceBooth className="min-w-[50px]" />
																: item?.["icon-class"] === 'customer-services' ?
																	<Help className="min-w-[50px]" />
																	: item?.["icon-class"] === 'ticket' ?
																		<Ticket className="min-w-[50px]" />
																		: item?.["icon-class"] === 'divyang' ?
																			<WheelChairSvg className="min-w-[50px]" />
																			: item?.["icon-class"] === 'travel' ?
																				<Help className="min-w-[50px]" />
																				: item?.["icon-class"] === 'bank' ?
																					<Help className="min-w-[50px]" />
																					: item?.["icon-class"] === 'mall' ?
																						<Help className="min-w-[50px]" />
																						: item?.["icon-class"] === 'shop' ?
																							<Help className="min-w-[50px]" />
																							: item?.["icon-class"] === 'basic-facilities' ?
																								<Water className="min-w-[50px]" />
																								:
																								''
										}
										<div className='flex flex-col gap-[4px]'>
											<h4 className='font-semibold text-blackDull dark:text-textBlackDull'>{i?.facility_name}</h4>
											{!!item?.location_description && <div className='flex gap-[8px]'>
												<LocationSvg />
												<h6 className='text-blackDull dark:text-textBlackDull font-medium'>
													{item?.location_description}
												</h6>
											</div>}
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				))}
			</div>}
		</>
	);
};

export default StationsFacilities;